import type { ExportTaskList, NotificationList } from '../../shared/api-client.js';

const FALLBACK_FAILURE_PREFIX = '文件生成失败：';
const FALLBACK_FAILURE_MESSAGE = '文件生成失败，请稍后重试。';

export function exportTaskFailureReason(
  item: Pick<ExportTaskList['items'][number], 'status' | 'failureCode' | 'failureReason'>,
) {
  return item.status === 'FAILED' &&
    item.failureCode === 'EXPORT_GENERATION_FAILED' &&
    item.failureReason?.startsWith(FALLBACK_FAILURE_PREFIX)
    ? FALLBACK_FAILURE_MESSAGE
    : item.failureReason;
}

export function exportNotificationMessage(
  item: Pick<NotificationList['items'][number], 'notificationType' | 'message'>,
) {
  return item.notificationType === 'EXPORT_FAILED' &&
    item.message.startsWith(FALLBACK_FAILURE_PREFIX)
    ? FALLBACK_FAILURE_MESSAGE
    : item.message;
}
